import { connect } from 'react-redux'
import {
  selectShowDemoMailboxBar,
  selectDoesCurrentMailboxHaveState,
} from 'selectors/mailboxes'
import {
  selectShowExpiredBilling,
  selectShowPendingCancellation,
  selectCancelsAt,
  selectShowCreditCardExpireSoon,
  selectShowCreditCardExpired,
  selectPrimaryCreditCard,
  selectShowLastBillingFailed,
  selectShowTrialMessage,
  selectDaysLeftBeforeExpiring,
} from 'ducks/billing/selectors'
import {
  selectCurrentUserIsAdmin,
  selectCurrentUserIsOwner,
} from 'ducks/currentUser/selectors'
import { selectGitHubNeedsReinstall } from 'ducks/integrations/github'
import { selectShowUpgradeToShopifyV2Banner } from 'ducks/integrations/selectors'
import {
  selectShowLegacyWidgetEOLNotice,
  selectShowInboxSidebarThemeLaunchNotice,
} from 'selectors/app/base'
import { selectDisconnectedWidgets } from 'ducks/widgets/selectors/widgets'
import AppNoticesView from './view'

const select = state => ({
  showDemoMailboxBar: selectShowDemoMailboxBar(state),
  showExpiredBilling: selectShowExpiredBilling(state),
  showGitHubReauth: selectGitHubNeedsReinstall(state),
  showPendingCancellation: selectShowPendingCancellation(state),
  showCreditCardExpireSoon: selectShowCreditCardExpireSoon(state),
  showCreditCardExpired: selectShowCreditCardExpired(state),
  showLastBillingFailed: selectShowLastBillingFailed(state),
  creditCard: selectPrimaryCreditCard(state),
  cancelsAt: selectCancelsAt(state),
  showTrialMessage: selectShowTrialMessage(state, 'inbox'),
  trialDaysLeft: selectDaysLeftBeforeExpiring(state, 'inbox'),
  showLegacyWidgetEOLNotice: selectShowLegacyWidgetEOLNotice(state),
  isAdmin: selectCurrentUserIsAdmin(state),
  isOwner: selectCurrentUserIsOwner(state),
  isCurrentMailboxConfirmedOrUnconfirmed: selectDoesCurrentMailboxHaveState(
    state,
    ['unconfirmed'],
    null,
    ['FORWARDING']
  ),
  isCurrentMailboxDisconnected: selectDoesCurrentMailboxHaveState(state, [
    'disconnected',
  ]),
  isCurrentMailboxConfirmedOrUnconfirmedLegacy: selectDoesCurrentMailboxHaveState(
    state,
    ['unconfirmed'],
    null,
    ['LEGACY']
  ),
  showUpgradeToShopifyV2Banner: selectShowUpgradeToShopifyV2Banner(state),
  disconnectedWidgets: selectDisconnectedWidgets(state),
  showInboxSidebarThemeLaunchNotice: selectShowInboxSidebarThemeLaunchNotice(
    state
  ),
})

export default connect(select)(AppNoticesView)
